"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_URL = void 0;
exports.BASE_URL = (process.env.API_BASE_URL || '');
